import script from "./RoleManageView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManageView.vue?vue&type=script&setup=true&lang=js"

import "./RoleManageView.vue?vue&type=style&index=0&id=26ea438d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ea438d"]])

export default __exports__